const SECOND = 1000

export const PROGRAM_OPTIONS_TIMEOUT = 25 * SECOND

export const COMMAND_TIMEOUT = 25 * SECOND

export const FIRMWARE_TIMEOUT = 25 * SECOND
